module.exports = __webpack_public_path__ + "static/media/plus-circle-white.a9ebd260.svg";